import { GridColDef } from "@mui/x-data-grid";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router";

import GaiaDataGrid from "~/modules/app/components/GaiaTable";
import GaiaTableLinkCell from "~/modules/app/components/GaiaTableLinkCell";
import { renderItalicCell } from "~/modules/settings/util/dataGridHelper";

import { FunctionTypeDataGridFragment } from "./fragments.generated";

interface Props {
    functionTypes: FunctionTypeDataGridFragment[];
    researchTypeId: string;
}

export default function FunctionTypeDataGrid({ functionTypes, researchTypeId }: Props) {
    const { t } = useTranslation("researchType");

    const columns: GridColDef[] = useMemo(
        () => [
            {
                field: "name",
                headerName: t("functionTypeDataGrid.headerName"),
                flex: 1,
            },
            {
                field: "observationTypes",
                headerName: t("functionTypeDataGrid.headerObservationTypes"),
                flex: 1,
                valueGetter: (_, row) => {
                    return row.observationTypes?.map((ot: { name: string }) => ot.name).join(", ") || "";
                },
                renderCell: renderItalicCell,
            },
            {
                type: "actions",
                field: `id`,
                headerName: "",
                maxWidth: 40,
                valueGetter: (functionTypeId, _row) =>
                    generatePath("/admin/settings/researchType/:researchTypeId/functionType/:functionTypeId/", {
                        functionTypeId,
                        researchTypeId,
                    }),
                renderCell: props => <GaiaTableLinkCell value={props.value} />,
            },
        ],
        [t, researchTypeId],
    );
    return <GaiaDataGrid rows={functionTypes} columns={columns} rowCount={functionTypes.length} />;
}
